import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/common/Placeholder';
import { useTranslation } from 'react-i18next';
import { Paper } from '@mui/material';
import { StyledTable, StyledTableContainer } from 'components/common/Styles';
import FinancialProductRulesEditDetailsCommissionsTableHead from './FinancialProductRulesEditDetailsCommissionsTableHead';
import FinancialProductRulesEditDetailsCommissionsTableBody from './FinancialProductRulesEditDetailsCommissionsTableBody';
import { get } from '@totalsoft/change-tracking-react';

const FinancialProductRulesEditDetailsCommissionsTable = ({
  canWrite,
  commissionList,
  isSaved,
  onDelete,
  financialProductRuleCommissionValidation
}) => {
  const [t] = useTranslation();

  return (
    <>
      <StyledTableContainer component={Paper}>
        <StyledTable>
          <FinancialProductRulesEditDetailsCommissionsTableHead canWrite={canWrite} isSaved={isSaved} />
          {isSaved && (
            <FinancialProductRulesEditDetailsCommissionsTableBody
              canWrite={canWrite}
              commissionList={commissionList}
              onDelete={onDelete}
              financialProductRuleCommissionValidation={financialProductRuleCommissionValidation}
            />
          )}
        </StyledTable>
      </StyledTableContainer>
      {!isSaved && <Placeholder message={t('FinancialProduct.Details.Rules.Details.PleaseCompleteGeneralData')} color={'warning'} />}
      {isSaved && (commissionList |> get)?.length === 0 && <Placeholder message={t('TableIsEmpty')} color={'gray'} />}
    </>
  );
};

FinancialProductRulesEditDetailsCommissionsTable.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  commissionList: PropTypes.object.isRequired,
  isSaved: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  financialProductRuleCommissionValidation: PropTypes.object.isRequired
};

export default FinancialProductRulesEditDetailsCommissionsTable;
